import React from 'react';
import { Flex, Box, Text } from '@chakra-ui/core';
import { Link } from './Core';
import LinkedInIcon from './assets/icons/icon-linkedin.svg';
import InstagramIcon from './assets/icons/icon-instagram.svg';
import StravaIcon from './assets/icons/icon-strava.svg';
import GitHubIcon from './assets/icons/icon-github.svg';

function Body() {
    const iconStyle = {
        marginRight: '16px',
        transition: 'filter 0.2s ease-in-out',
        display: 'inline-block'
    };

    return (
        <Flex width="100%" maxW="720px" direction="column">
            <style>{`
                .social-icon {
                    filter: brightness(0);
                }
                .social-icon:hover {
                    filter: invert(50%) sepia(98%) saturate(2476%) hue-rotate(310deg) brightness(100%) contrast(101%);
                }
            `}</style>
            <Box fontSize={["xl", "2xl", "2xl", "3xl"]}>
                <Text as="h1" fontWeight="bold">Hello, my name is<br />Jan Senderek.</Text>
            </Box>
            <Box fontSize="sm">
                <Text fontWeight="light" lineHeight="taller" marginTop="8">I'm a designer and product founder. I love building software for people, and sometimes that person is me. <Link href="https://www.theverge.com/2013/7/24/4549932/loom-for-ios-the-infinite-camera-roll-is-finally-here">Loom</Link> (YC W12) started that way, a passion project born out of my love for photography. It went on to win a Webby and get named one of The Verge's best apps of the year before being acquired by Dropbox. <Link href="https://milo.app">Milo</Link> came out of my love for running and cycling.</Text>
                <Text fontWeight="light" lineHeight="taller" marginTop="8">Now I'm building <Link href="https://roma.app">Roma</Link>, an AI-powered task management app, and my second company to go through Y Combinator. Roma is a product I've been trying to build in one form or another for over a decade, and it's only now with AI, that it's actually possible. If you're the kind of person with a trillion tasks, you just might want to give it a spin.</Text>
            </Box>
            <Box mt="16">
                <Flex>
                    <a href="https://www.linkedin.com/in/jansenderek/" target="_blank" rel="noopener noreferrer" className="social-icon" style={iconStyle}>
                        <img src={LinkedInIcon} alt="LinkedIn" width="32" height="32" />
                    </a>
                    <a href="https://www.instagram.com/moopoints" target="_blank" rel="noopener noreferrer" className="social-icon" style={iconStyle}>
                        <img src={InstagramIcon} alt="Instagram" width="32" height="32" />
                    </a>
                    <a href="https://www.strava.com/athletes/1005434" target="_blank" rel="noopener noreferrer" className="social-icon" style={iconStyle}>
                        <img src={StravaIcon} alt="Strava" width="32" height="32" />
                    </a>
                    <a href="https://github.com/moopoints" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ transition: 'filter 0.2s ease-in-out', display: 'inline-block' }}>
                        <img src={GitHubIcon} alt="GitHub" width="32" height="32" />
                    </a>
                </Flex>
            </Box>
        </Flex>
    );
};

export default Body;
